import request from '@/utils/request'

/**
 * 用户屏蔽关系接口（他人主页的「不看他」/「不让他看」）
 *
 * 与黑名单（api/blacklist.js）是两套不同的东西，服务端也是两张表，别混：
 *   拉黑     断绝往来，双方发不了私信，在「账号设置-黑名单」里管理
 *   不看他   对方的内容不再进入我的推荐流，我主动点进他主页仍然看得到
 *   不让他看 对方看不到我主页里发布的内容
 *
 * 服务端三个接口都是 GET（含 toggle 这个写操作），照抄 ApiUserBlockController 的映射，
 * 不擅自改成 POST。
 */

/** 屏蔽类型：不看他（屏蔽对方内容） */
export const BLOCK_TYPE_CONTENT = 1
/** 屏蔽类型：不让他看（禁止对方查看我的内容） */
export const BLOCK_TYPE_VIEW = 2

/**
 * 切换屏蔽开关。
 *
 * 是幂等的开/关切换而不是「只能开」：同一个入口点一次开、再点一次关，
 * 所以名单页里的「解除」也复用这个接口，不需要额外的 remove。
 *
 * @param {String|Number} targetUserId 目标用户 id
 * @param {Number} type BLOCK_TYPE_CONTENT | BLOCK_TYPE_VIEW
 * @returns {Promise} data 为 { isActive, blockContent, blockView }
 */
export function toggleUserBlock (targetUserId, type) {
  return request({
    url: '/v1/userBlock/toggle',
    method: 'get',
    params: { targetUserId, type }
  })
}

/**
 * 查询我对目标用户的屏蔽与拉黑状态。
 *
 * 一次拿到三个开关，供他人主页的三点菜单打开时一次性回显，
 * 不必并发打三个接口让菜单项一个个跳变。
 *
 * @param {String|Number} targetUserId 目标用户 id
 * @returns {Promise} data 为 { blockContent, blockView, inBlacklist }
 */
export function getUserBlockStatus (targetUserId) {
  return request({
    url: '/v1/userBlock/status',
    method: 'get',
    params: { targetUserId }
  })
}

/**
 * 分页获取我的屏蔽名单。
 *
 * 分页参数走 params 而不是 data：服务端由 PageableInterceptor 从 query 上取
 * （与 blacklist.js 的 getBlacklistList 一致）。
 *
 * @param {Object} params
 * @param {Number} params.type     1-不看他，2-不让他看
 * @param {Number} params.pageNo   页码，从 1 开始
 * @param {Number} params.pageSize 每页条数
 * @returns {Promise} data 为 MyBatis-Plus 分页对象：{ records, total, current, size, pages }
 */
export function getUserBlockList (params) {
  return request({
    url: '/v1/userBlock/list',
    method: 'get',
    params
  })
}
